import snakeCase from 'lodash/snakeCase';
import {useSelector} from 'react-redux';
import {Pledgeling} from '~/CreateFabricInvitation/components/Pledgeling/Pledgeling';
import {selectEventType} from '~/CreateFabricInvitation/reducers/fabricTemplate/selectors';
import {selectTemplateName} from '~/common/fabric/reducers/fabricTemplate/selector';
import {ResponsivePanel} from '~library/organisms/ResponsivePanel';

import './PledgelingOverlay.sass';

export const PledgelingOverlay = ({overlayTitle, closeOverlay, backClicked, isOpen, ...props}) => (
  <ResponsivePanel
    isOpen={isOpen}
    onClose={closeOverlay}
    title={overlayTitle}
    modalId={snakeCase(overlayTitle)?.toLowerCase() ?? 'create-flow__overlay'}
    showCover
    renderMobileViewAs="bottom-sheet"
  >
    <div className="gifting__overlay__body__content">
      <OverlayContent
        overlayTitle={overlayTitle}
        closeOverlay={() => closeOverlay(overlayTitle)}
        backClicked={backClicked}
        {...props}
      />
    </div>
  </ResponsivePanel>
);

const OverlayContent = ({overlayTitle, closeOverlay, backClicked, ...props}) => {
  const giftingOptions = useSelector((state) => state.giftingOptions);
  const eventType = useSelector(selectEventType) || window.evite_event?.event_type || 'empty';
  const templateName = useSelector(selectTemplateName);
  const isSesame = templateName.indexOf('sesamestreet-') === 0;
  const {Organization, Crowdfund} = giftingOptions?.pledgeling_data || {};

  switch (overlayTitle) {
    case 'charity-donation':
      return (
        <Pledgeling
          pledgeKey={window.pledge_key}
          organizationPledgelingId={Organization?.pledgeling_id}
          organizationPledgelingGoal={Organization?.pledgeling_goal}
          eventType={eventType || window.evite_event.event_type}
          onClick={closeOverlay}
          disabled={!props.charityAdded}
          isSesame={isSesame}
          pledgeUrl={window.pledge_url}
          dataQaId="charitySaveButton"
          pledgeType="charity-donation"
        />
      );

    case 'crowd-funding':
      return (
        <Pledgeling
          pledgeKey={window.pledge_key}
          organizationPledgelingGoal={Crowdfund?.pledgeling_goal}
          organizationPledgelingPurpose={Crowdfund?.pledgeling_purpose}
          eventType={eventType || window.evite_event.event_type}
          onClick={closeOverlay}
          disabled={!props.crowdfundAdded}
          pledgeUrl={window.pledge_url}
          dataQaId="crowdfundingSaveButton"
          pledgeType="crowd-funding"
        />
      );

    default:
      return <p>Something went wrong.</p>;
  }
};
